(function () {
  'use strict';

  function lockScroll() {
    document.documentElement.classList.add('nine-video--scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('nine-video--scroll-lock');
  }

  function NineVideoSection(root) {
    this.root = root;
    this.provider = root.getAttribute('data-video-provider') || 'none';
    this.dialog = root.querySelector('[data-nine-video-dialog]');
    this.openBtn = root.querySelector('[data-nine-video-open]');
    this.closeEls = root.querySelectorAll('[data-nine-video-close]');
    this.hostedVideo = root.querySelector('[data-nine-video-hosted]');
    this.iframe = root.querySelector('[data-nine-video-iframe]');
    this.youtubeMount = root.querySelector('[data-nine-video-youtube]');
    this.youtubeId = root.getAttribute('data-youtube-id');
    this.youtubePlayer = null;
    this.lastFocus = null;
    this.playBadge = root.querySelector('[data-nine-video-play]');
    this.replayMarked = false;

    this.bindYoutubeThumbs();
    this.bind();
  }

  NineVideoSection.prototype.bindYoutubeThumbs = function () {
    this.root.querySelectorAll('[data-nine-video-yt-thumb]').forEach(function (img) {
      var fallback = img.getAttribute('data-fallback-src');
      if (!fallback) return;
      img.addEventListener('error', function onError() {
        if (img.getAttribute('src') === fallback) return;
        img.removeEventListener('error', onError);
        img.setAttribute('src', fallback);
      });
    });
  };

  NineVideoSection.prototype.bind = function () {
    var self = this;
    if (this.openBtn) {
      this.openBtn.addEventListener('click', function () {
        self.open();
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event": "ga4Event",
          "event_name": "select_content",
          "event_parameters": {
            "content_type": "video",
            "content_name": "จุดเริ่มต้นของเรา",
            "button_name": "click_video"
          }
        });
      });
    }
    this.closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.dialog && self.dialog.classList.contains('is-open')) {
        self.close();
      }
    });
  };

  NineVideoSection.prototype.open = function () {
    if (!this.dialog) return;
    this.lastFocus = document.activeElement;
    this.dialog.removeAttribute('hidden');
    this.dialog.classList.add('is-open');
    this.dialog.setAttribute('aria-hidden', 'false');
    lockScroll();
    this.play();
  };

  NineVideoSection.prototype.close = function () {
    if (!this.dialog) return;
    var wasOpen = this.dialog.classList.contains('is-open');
    this.dialog.classList.remove('is-open');
    this.dialog.setAttribute('aria-hidden', 'true');
    this.dialog.setAttribute('hidden', '');
    unlockScroll();
    this.stop();
    if (wasOpen) {
      this.markReplay();
    }
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }
  };

  NineVideoSection.prototype.markReplay = function () {
    if (this.replayMarked || !this.playBadge) return;
    this.replayMarked = true;
    this.playBadge.classList.add('replay');
  };

  NineVideoSection.prototype.play = function () {
    if (this.provider === 'hosted' && this.hostedVideo) {
      this.hostedVideo.play().catch(function () { });
      return;
    }
    if (this.provider === 'vimeo' && this.iframe) {
      var vimeoSrc = this.iframe.getAttribute('data-src');
      if (vimeoSrc && !this.iframe.getAttribute('src')) {
        this.iframe.setAttribute('src', vimeoSrc);
      }
      return;
    }
    if (this.provider === 'youtube' && this.youtubeMount && this.youtubeId) {
      this.initYoutube();
    }
  };

  NineVideoSection.prototype.stop = function () {
    if (this.provider === 'hosted' && this.hostedVideo) {
      this.hostedVideo.pause();
      this.hostedVideo.currentTime = 0;
      return;
    }
    if (this.provider === 'vimeo' && this.iframe) {
      this.iframe.setAttribute('src', '');
      return;
    }
    if (this.youtubePlayer && typeof this.youtubePlayer.stopVideo === 'function') {
      this.youtubePlayer.stopVideo();
    }
  };

  NineVideoSection.prototype.initYoutube = function () {
    var self = this;
    if (this.youtubePlayer) {
      if (window.ShokzYouTubeIframe) {
        ShokzYouTubeIframe.promoteYoutubeIframeSrc(this.dialog);
      }
      this.youtubePlayer.playVideo();
      return;
    }
    if (!window.ShokzYouTubeIframe) return;
    ShokzYouTubeIframe.ready(function () {
      if (!self.youtubeMount || self.youtubePlayer) return;
      self.youtubePlayer = new YT.Player(self.youtubeMount.id, {
        videoId: self.youtubeId,
        width: '100%',
        height: '100%',
        playerVars: {
          autoplay: 1,
          rel: 0,
          playsinline: 1,
        },
        events: {
          onReady: function () {
            if (window.ShokzYouTubeIframe) {
              ShokzYouTubeIframe.promoteYoutubeIframeSrc(self.dialog);
            }
            self.youtubePlayer.playVideo();
          },
        },
      });
    });
  };

  function init() {
    document.querySelectorAll('[data-nine-video]').forEach(function (root) {
      if (root.nineVideoBound) return;
      root.nineVideoBound = true;
      new NineVideoSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
